import { ElMessageBox } from 'element-plus'

export async function DeleteConfirmationModal(
  title: string,
  message: string,
  resourceIdentifier: any,
  deleteMutateAsyncFn: (resourceIdentifier: any) => Promise<any>,
  afterAction?: () => void,
  deleteButtonText?: string
): Promise<any> {
  await ElMessageBox({
    title,
    message,
    showCancelButton: true,
    dangerouslyUseHTMLString: true,
    confirmButtonText: deleteButtonText ?? 'Delete',
    confirmButtonClass: 'el-button--danger',
    beforeClose: async (action, instance, done) => {
      if (action === 'confirm') {
        instance.confirmButtonText = 'Loading...'
        instance.confirmButtonLoading = true
        try {
          await deleteMutateAsyncFn(resourceIdentifier)
          if (afterAction) afterAction()
        } catch {
          // Errors should already be processed on the onError callback from deleteFn
        }
      }
      done()
    },
  }).catch(() => {
    // ElMessageBox throws an Error on cancel click (in this case, do nothing).
  })
}
